import generalService from '../../services/generalService';
import axios from 'axios';
import _ from 'lodash';

// initial state
const state = {
  pages:[],
  sliders:[],
  language:localStorage.getItem('language') ? localStorage.getItem('language') : 'english'
}

// getters
const getters = {
}

// actions
const actions = {
    sendEnquiry(context, params){
      return new Promise((resolve, reject) => {
        generalService.sendEnquiry(params)
        .then((resp) => {
            resolve(resp)
        })
        .catch(err => {
            reject(err)
        })
      })
    },
    sendGuestEnquire(context ,params){
      return new Promise((resolve, reject) => {
        generalService.sendGuestEnquire(params)
        .then(resp => {
            resolve(resp)
        })
        .catch(err => {
            reject(err)
        })
      })
    },
    getPages(context, params){
      return new Promise((resolve, reject) => {
        generalService.getPages(params)
        .then(resp => {
          resolve(resp.data)
          context.commit('set_pages',resp.data)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    getSliders(context, params){
      return new Promise((resolve, reject) => {
        generalService.getSliders(params)
        .then(resp => {
            resolve(resp)
            context.commit('set_sliders',resp.data)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    sendAnalysisForm(context, params){
      return new Promise((resolve, reject) => {
        generalService.sendNeedsAnalysisForm(params)
        .then(resp => {
            resolve(resp)
        })
        .catch(err => {
            reject(err)
        })
      })
    }
}

// mutations
const mutations = {
  set_pages(state,pages){
    state.pages = pages
  },
  set_sliders(state, sliders) {
    state.sliders = sliders
  },
  set_language(state, language){
    localStorage.setItem('language', language)
    state.language = language
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}